import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';

import { TFunction } from '@lyearn/i18n';
import { ExerciseQuestionInput, ResourceResponseTypeEnum } from '@/types/schema';

import validateImageHotspot from './imageHotspot';
import validateLikert from './likert';

export const isQuestionTextEmpty = (question: ExerciseQuestionInput) =>
  isEmpty(trim(question.text));

export const validateExerciseQuestion = (t: TFunction, question: ExerciseQuestionInput) => {
  if (isEmpty(trim(question.text))) {
    return {
      message: t('Exercise:Creator.EmptyQuestionError'),
    };
  }

  if (question.responseType === ResourceResponseTypeEnum.ImageHotspot) {
    const error = validateImageHotspot(t, question);
    if (error) {
      return error;
    }
  }

  if (question.responseType === ResourceResponseTypeEnum.Likert) {
    const error = validateLikert(t, question);
    if (error) {
      return error;
    }
  }
};

export const isAnyExerciseQuestionInvalid = (t: TFunction, questions: ExerciseQuestionInput[]) => {
  let questionsError = false;

  questions.forEach((question) => {
    const error = validateExerciseQuestion(t, question);

    if (error) {
      questionsError = true;
    }
  });

  return questionsError;
};
